import React from 'react'
import type { CheckboxValueType } from 'antd/es/checkbox/Group'
import { useSelector } from 'react-redux'
import { getMunicipality } from '../../store/beslutsstod/municipalitySlice'
import { MunicipalityData } from './types/municipalityData'
import { JSONLoadError } from './utils/jsonLoader'
import TimepointTaskTable from './components/timepointTaskTable'

type Props = {
  timepoints: CheckboxValueType[]
  loadingErrors?: JSONLoadError[]
}

const TimepointsTasks: React.FC<Props> = ({ timepoints, loadingErrors }) => {
  const municipalityData = useSelector(getMunicipality) as MunicipalityData

  if (!municipalityData) return null

  // Rendera alltid tidpunkterna i konfigurationens (kronologiska) ordning, oavsett i vilken ordning de
  // valdes eller sparades. Vid inläsning av en sparad beräkning kommer listan i inmatningsordning, så
  // utan detta hamnar tidpunkterna (Morgon, Förmiddag, Lunch ...) huller om buller.
  const order = municipalityData.input.timepoints
  const allTimepoints = timepoints.map((t) => t.toString()).sort((a, b) => order.indexOf(a) - order.indexOf(b))

  return (
    <>
      {allTimepoints.map((timepoint) => (
        <TimepointTaskTable
          key={timepoint}
          timepoint={timepoint}
          tasks={municipalityData.input.timepointTasks}
          loadingErrors={loadingErrors}
          allTimepoints={allTimepoints}
        />
      ))}
    </>
  )
}

export default TimepointsTasks
